import { API_VERSION, TASK_SERVICE, X_API_VERSION } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_ASSIGNMENTS = `${TASK_SERVICE}/assignments`;

export const assignments = {
  submitStepResult: async ({
    assignmentId,
    attemptId,
    stepId,
    stepResultId,
    data,
    toastMessageConfig,
  }) => {
    const options = await apiOptions({
      url: `${API_ASSIGNMENTS}/${assignmentId}/attempts/${attemptId}/steps/${stepId}/step-results/${stepResultId}/submit`,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
};
